import ProfilDHIContent from "../../components/layouts/tentang/ProfilDHIContent";

import React from "react";

const Profil: React.FC = () => {
  return (
    <div>
      <ProfilDHIContent />
    </div>
  );
};

export default Profil;
